




















import { defineComponent, onMounted} from "@nuxtjs/composition-api";
import PBHelper from "~/components/PageBuilder/utils/helper";
import {useGtm} from "~/composables";
import {trim} from "lodash-es";
// import { trim } from "lodash-es";

export default defineComponent({
  name: "MediaVideo",
  props: {
    tag: {
      type: String,
      default: "div",
    },
    node: {
      type: String,
      default: "div",
    },
    attr: {
      type: Object,
      default: () => {},
    },
    children: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { checkVideoType } = PBHelper();
    const { eventVideoInteracted } = useGtm();

    onMounted( async () => {
      const video = document.querySelector('video');
      const videoCallback = (e) => {
        const target = e.target;
        eventVideoInteracted({
          "videoName": trim(target.src.substring(target.src.lastIndexOf('/')+1)),
          "videoState": target.readyState,
          "videoMileStone":Math.ceil(target.currentTime/target.duration*100) + '%',
        });
      };
      if (video) {
        video.onplay = videoCallback;
        video.onseeked = videoCallback;
        video.onpause = videoCallback;
      }
    });
    return {
      checkVideoType
    };
  }
});
